import {StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';

export const styles = StyleSheet.create({
  containerOneI: {
    width: 160,
    height: 380,
    borderWidth: 1,
    borderColor: Colors.lightGray,
    paddingHorizontal: 10,
    marginRight: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
    backgroundColor: 'white',
    borderRadius: 8,
    paddingVertical: 10,
  },
  emptyImageStyle: {
    width: 74,
    height: 68,
    alignSelf: 'center',
    marginVertical: 7,
  },
  imageStyle: {
    width: 100,
    height: 100,
    alignSelf: 'center',
    marginVertical: 7,
  },
  title: {
    maxWidth: 150,
    fontSize: 12,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: 'black',
  },
  description: {
    maxWidth: 150,
    fontSize: 11,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 15,
    color: 'gray',
    paddingTop: 10,
  },
  price: {
    fontSize: 10,
    marginRight: 8,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 12,
    color: 'black',
  },
  priceRangesContainer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  priceRange: {
    marginTop: 1.5,
    fontSize: 10,
    color: '#333',
  },
  hasItem: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: 'gray',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto',
  },
  quantity: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: 'gray',
  },
  infoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
  },
});
